import { actionKeyCodes } from '../config/action-key-codes';
import { log, logWarning } from '../utils/logger';

/**
 * Hamburger component
 *
 * @param {string} openEvent event title to dispatch
 * @param {string} closeEvent event title to dispatch
 */
export default function cHamburger(openEvent, closeEvent) {
  /**
   * hamburger button class
   * @type {Element|null}
   */
  const hamburger = document.querySelector('.c-hamburger');

  /**
   * hamburger items
   * @type {NodeListOf<Element>|[]}
   */
  const hamburgerItems = document.querySelectorAll('.c-hamburger__item');

  /**
   * Hamburger open state class
   * @type {string}
   */
  const hamburgerOpenClass = 'c-hamburger--state-open';

  /**
   * Hamburger item open state class
   * @type {string}
   */
  const hamburgerItemClass = 'c-hamburger__item--state-open';

  /**
   * Run open animation and dispatch event if needed
   * @param dispatchEvent {boolean} dispatch event or not
   * @return {*|boolean}
   */
  function open(dispatchEvent = true) {
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add(hamburgerOpenClass);
    hamburgerItems.forEach((el) => el.classList.add(hamburgerItemClass));

    if (dispatchEvent) {
      return document.dispatchEvent(new Event(openEvent));
    }

    return true;
  }

  /**
   * Run close animation and dispatch event if needed
   * @param dispatchEvent {boolean} dispatch event or not
   * @return {*}
   */
  function close(dispatchEvent = true) {
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove(hamburgerOpenClass);
    hamburgerItems.forEach((el) => el.classList.remove(hamburgerItemClass));

    if (dispatchEvent) {
      return document.dispatchEvent(new Event(closeEvent));
    }

    return true;
  }

  /**
   * toggle hamburger button
   */
  function toggle() {
    return hamburger.classList.contains(hamburgerOpenClass) ? close() : open();
  }

  if (hamburger && hamburgerItems.length) {
    ['click', 'tap'].forEach((event) => {
      hamburger.addEventListener(event, (evt) => {
        if (!actionKeyCodes.includes(evt.keyCode)) {
          return false;
        }

        return toggle();
      });
    });

    // run animation on external events
    document.addEventListener(openEvent, () => open(false));
    document.addEventListener(closeEvent, () => close(false));

    log('Hamburger initialized');
  } else {
    logWarning('Not found hamburger on page 🤔');
  }
}
